import React, {
    useContext, useState, useEffect, useRef,
} from 'react';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { HeaderContext } from '@contexts/HeaderContext';
import { getCookie, setCookie } from '@utils/cookieUtils';
import { postLoginCallback } from '@utils/LoginProcess/LoginProcess';
import { postLoginData } from '@utils/LoginProcess/requests';
import { useSiteInfo } from '@contexts/SiteInfoContext';

let lockScreen; // 這個變數不能刪

const Gesture = ({
    loginMode, username, setLoginMode, getGestureUsers, changeGestureUser, addGestureAccount, userNameIndex,
}) => {
    const [state] = useContext(HeaderContext);
    const { t } = useTranslation();
    const { language, platform } = state;
    const [isDomLoaded, setIsDomLoaded] = useState(false);
    const [isShowDropdown, setIsShowDropdown] = useState(false);
    const { locale } = useRouter();
    const { ip, clientApiUrl } = useSiteInfo();
    const userListDropdownRef = useRef(null);
    useEffect(() => {
        setIsDomLoaded(true);
        return (() => {
            if (document.getElementById('gestureInput')) {
                document.getElementById('gestureInput').remove();
            }
        });
    }, []);

    const focusHandle = (event) => {
        if (!(userListDropdownRef.current && userListDropdownRef.current.contains(event.target))) {
            setIsShowDropdown(false);
        }
    };

    useEffect(() => {
        if (isShowDropdown) {
            window.addEventListener('click', focusHandle);
        }

        return () => {
            window.removeEventListener('click', focusHandle);
        };
    }, [isShowDropdown]);

    const onSelected = (gesture, scb, fcb) => {
        const isGestureLogin = true;
        setCookie('rememberMe', true, 365); // 1 year
        const gestureLoginData = {
            username,
            password: gesture,
            isGesture: true,
            platform,
            language,
        };

        postLoginData(clientApiUrl + '/api/Login', gestureLoginData)
            .then((response) => (postLoginCallback(
                clientApiUrl,
                response,
                gestureLoginData,
                null,
                locale,
                ip,
                true, // check remember me
                isGestureLogin,
                t,
                scb,
                fcb,
                getGestureUsers,
                setLoginMode,
            )))
            .catch((error) => console.error(error));
    };

    const getGestureList = () => {
        const ret = [];
        let gesUser = getCookie('UserName');
        if (gesUser && gesUser !== '') {
            gesUser = gesUser.split(',');
        } else {
            gesUser = [];
        }
        let gesList = getCookie('ges');
        if (gesList && gesList !== '') {
            gesList = gesList.split(',');
        } else {
            gesList = [];
        }

        for (let i = 0; i < gesList.length; i += 1) {
            if (gesUser.indexOf(gesList[i]) >= 0) {
                ret.push(gesList[i]);
            }
        }

        if (ret.length > 5) ret.length = 5;
        return ret;
    };

    const initGesture = () => {
        let showGesTip = false;
        if (!getCookie('gesTip')) {
            showGesTip = true;
            setCookie('gesTip', 1, 7);
        }
        const data = {};
        data.lang = state.language;
        data.parent = 'divLogin';
        data.lockType = 'smallUnLock';
        data.userName = username;
        data.showTip = showGesTip;
        data.loginRemain = t('lbl_GesturePWD_login');
        data.users = getGestureList();
        data.first = false;
        data.t = $;
        data.mcb = onSelected;
        data.crcb = function (user) {
            let uNames = getCookie('UserName');
            if (uNames && uNames !== '') {
                uNames = uNames.split(',');
            } else {
                uNames = [];
            }
            const arrIdx = uNames.indexOf(user);
            if (arrIdx >= 0) {
                uNames.splice(arrIdx, 1);
            }
            uNames.unshift(loginData.username);
            setCookie('UserName', uNames.join(','), 365);
        };

        lockScreen = new GestureClass(data);
    };

    useEffect(() => {
        if (isDomLoaded) {
            initGesture();
        }
    }, [isDomLoaded]);

    useEffect(() => {
        if (document.getElementById('gestureInput')) {
            document.getElementById('gestureInput').remove();
        }
        initGesture();
    }, [username, platform]);

    if (!isDomLoaded) return [];

    return (
        <div id="divLogin" className="login-gesture" data-open={loginMode === 'gesture-password'}>
            <div className="dropdown" data-open={isShowDropdown} ref={userListDropdownRef}>
                <div className="dropdown__btn" onClick={() => setIsShowDropdown(!isShowDropdown)}>
                    <i className="icon icon--my-account" />
                    <span className="text">{username?.split(',')[userNameIndex] || username}</span>
                    <i className="icon icon--arrow-down" />
                </div>
                <div className="dropdown__container">
                    {getGestureList()?.map((item) => (
                        <div className="dropdown__list" key={item}>
                            <div
                                className="dropdown__item"
                                data-selected={item === username}
                                onClick={() => { changeGestureUser(item); setIsShowDropdown(false); }}
                            >
                                <i className="icon icon--my-account" />
                                <span className="text">{item}</span>
                                <i className="icon icon--done" />
                            </div>
                        </div>
                    ))}
                    <div className="dropdown__item" onClick={() => addGestureAccount()}>
                        <i className="icon icon--add-account" />
                        <span className="text">{t('lbl_AddAccount')}</span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Gesture;
